export default __webpack_public_path__ + "static/media/measurements_loader.cae98ddd.gif";